import { recoveryFromHash } from '@besuites/auth/flow';
import { emailChangeArrival } from '@/lib/email-change/email.change.arrival';
import { RECOVERY_PATH } from '@/config/email.change.config';

export default function authLinkBoot(): void {
    emailChangeArrival.capture();
    if (typeof window !== 'undefined' && recoveryFromHash(window.location.hash)) {
        window.history.replaceState(window.history.state, '', RECOVERY_PATH);
    }
}
